import AiAnalysisResult from "./AiAnalysisResult";
import RelatedKeyword from "./RelatedKeyword";
import DegreeSection from "./DegreeSection";
import MeasurementResult from "./MeasurementResult";

export default function DetailDarkCircle({data, img}) {
    return (
        <MeasurementResult type="다크서클" 
                            description='다크서클은 밤샘,야근, 스트레스, 눈의 피로 및 노화로 인해 눈가 피부와 혈관의 혈류 속도가 지나치게 느려지면서 정체됨으로써, 조직의 산소 공급이 부족해지고 혈관에 대사성 폐기물이 과도하게 축적되면서 눈가의 색소 침착을 유발하여 형성됩니다.' 
                            score={data.score}
        >

            <div className="row-wrap">
                <div className="img-wrap">
                    <div className="img-cont">
                        {
                        img.image_cross_polar_front &&
                        <img src={img.image_cross_polar_front} />
                        }
                        {
                        img.image_mark_dark_circle_front &&
                        <img src={img.image_mark_dark_circle_front} />
                        }

                        <div className="caption">2D</div>
                    </div>
                    {/* <div className="img-cont detail">
                        <div className="img">
                            <img src={process.env.PUBLIC_URL + "/image/img_report_result_detail_01.png"} />
                            <div className="caption">다크서클</div>
                        </div>
                    </div> */}
                </div>
                
                <DegreeSection 
                    type="다크서클"
                    badge={data.analysisBadge}
                    items={[
                    {
                        value: "없음",
                    },
                    {
                        value: "경도",
                    },
                    {
                        value: "중간 정도",
                    },
                    {
                        value: "중증 정도",
                    },
                ]}
                text={data.degreeText}
                line={3}
                />
            </div>


            <div className="row-wrap">
                {/* <section className="direction-row flex-grow-0">
                    <div className="h3">
                        다크서클
                        <br />
                        점유 비율
                    </div>
                    <DialChart value={data.percentage} />
                </section> */}
                <section className="darkcircle-type">
                    <div className="h4">다크서클 유형</div>

                    <div className="row-wrap">
                        <div className="img-cont">
                            <img src={process.env.PUBLIC_URL + "/image/img_report_result_darkcircle_type.png"} alt="" />
                        </div>

                        <div className="level-gauge-wrap">
                            <div className="left">
                                <div className="caption">정맥확장형</div>
                                <div className="report-badge">경도</div>
                            </div>

                            <div className="level-gauge">
                                {
                                Array(3).fill(0).map((el,idx) => {
                                    return (
                                        <div key={"skjfkdsf" + idx} className={data.troubleList.find(item => item.type == 1).degree >= idx+1 ? "fill" : ""}></div>
                                    )
                                })
                                }
                            </div>
                        </div>
                        <div className="level-gauge-wrap">
                            <div className="left">
                                <div className="caption">색소침착형</div>
                                <div className="report-badge">중간 정도</div>
                            </div>

                            <div className="level-gauge">
                                {
                                Array(3).fill(0).map((el,idx) => {
                                    return (
                                        <div key={"ddsasd_"+idx} className={data.troubleList.find(item => item.type == 2).degree >= idx+1 ? "fill" : ""}></div>
                                    )
                                })
                                }
                            </div>
                        </div>
                        <div className="level-gauge-wrap">
                            <div className="left">
                                <div className="caption">음영형</div>
                                <div className="report-badge">경도</div>
                            </div>

                            <div className="level-gauge">
                                {
                                Array(3).fill(0).map((el,idx) => {
                                    return (
                                        <div key={idx} className={data.troubleList.find(item => item.type == 4).degree >= idx+1 ? "fill" : ""}></div>
                                    )
                                })
                                }
                            </div>
                        </div>
                    </div>
                </section>
            </div>

            <div className="row-wrap grow">
                <RelatedKeyword list={data.keyword} />

                <AiAnalysisResult 
                    hideTitle={true}
                    text={data.aiResult} 
                    line={4}
                />
            </div>
        </MeasurementResult>
    )
}